/**
 * What a campaign can be narrowed to besides geo and device: the visitor's connection,
 * their OS and their browser.
 *
 * The ids are the backend's, and every screen that targets reads its labels from here. The
 * maps are keyed by `number` on purpose — the backend may send an id this file does not
 * know yet, so look one up defensively and fall back to the id.
 */

export const ConnectionTypeLabels: Record<number, string> = {
  1: 'Dialup',
  2: 'Cable',
  3: 'Corporate',
  4: 'Cellular',
  5: 'Other'
}

export const PlatformLabels: Record<number, string> = {
  1: 'Windows',
  2: 'Mac',
  3: 'Linux',
  4: 'Other',
  5: 'iOS',
  6: 'Android',
  7: 'ChromeOS',
  8: 'WinPhone',
  9: 'Blackberry',
  10: 'WebOS',
  11: 'Playstation',
  12: 'Xbox',
  13: 'Nintendo',
  14: 'Kindle'
}

export const BrowserLabels: Record<number, string> = {
  1: 'Microsoft Edge',
  2: 'Firefox',
  3: 'Chrome',
  4: 'Opera',
  5: 'Safari',
  6: 'Other',
  7: 'Android WebView',
  8: 'UC Browser',
  9: 'BlackBerry',
  10: 'Amazon Silk',
  11: 'Tencent QQ',
  12: 'Spotify',
  13: 'Yandex',
  14: 'Nintendo Browser',
  15: 'Samsung Internet',
  16: 'Coc Coc',
  17: 'Baidu App Box',
  18: 'Google Search App',
  19: 'Aloha Browser'
}
